import React, { FC } from 'react';

export const FlagIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5.00024H17.5C17.5776 5.00024 17.6542 5.01832 17.7236 5.05303C17.9706 5.17653 18.0707 5.47686 17.9472 5.72385L16.059 9.50024L17.9472 13.2766C17.9819 13.3461 18 13.4226 18 13.5002C18 13.7764 17.7761 14.0002 17.5 14.0002H7V20.0002H6V5.00024Z"
      fill="currentColor"
    />
  </svg>
);
